export default {
    base_url: null,
    controller_id: null,
    action_id: null,

    install( app, options ) {

        this.controller_id = options.controller_id;
        this.action_id = options.action_id;

        this.base_url = options.base_url;

        if ( !this.base_url || this.base_url[ this.base_url.length - 1 ] !== '/' ) {

            this.base_url += '/';
        }

        app.config.globalProperties.$url = ( route, params = {} ) => {

            let url = route;

            if ( !route ) {

                url = this.controller_id + '/' + this.action_id;
            } else if ( route[0] !== '/' ) {

                route = route.split( '/' );

                if ( route.length === 1 ) {

                    url = this.controller_id + '/' + route[ 0 ];
                }
            } else {

                // remove the leading /, because base_url has a trailing /
                url = url.substring( 1 );
            }

            const param_list = [];
            for ( const key in params ) {

                param_list.push( encodeURIComponent( key ) + '=' + encodeURIComponent( params[ key ] ) );
            }

            if ( param_list.length ) {

                url += '?' + param_list.join( '&' );
            }

            return this.base_url + url;
        }
    }
}